import moment from "moment";
const colorsArray = ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00', '#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00', '#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00', '#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'];

const numericValue = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
};

const findMeasureRegister = (event, field) => [...(event?.registros || [])]
    .sort(function (a, b) { return moment(b.createdAt) - moment(a.createdAt) })
    .find(e => e.vc_field === field);

export const processData = (customConfig = {}, valuesResponse = [], measuresSelected = [],) => {
    const orderedValues = [...valuesResponse].sort(function (a, b) { return moment(a.createdAt) - moment(b.createdAt) })
    const bat = ([...orderedValues].reverse()[0] || {})?.registros?.find(e => e.vc_field === 'BAT')?.nu_value || null;
    const visibleValues = orderedValues.filter((event) => measuresSelected.some((measure) => {
        const register = findMeasureRegister(event, measure.vc_fieldName);
        return numericValue(register?.nu_value) !== null;
    }));
    let gauge = {};
    const categories = visibleValues.map(e => moment(e.createdAt).format('DD-MM-YY HH:mm'));
    const series = [];
    let lastObj = null;
    measuresSelected.forEach((meas, indexMeas) => {
        let data = [];
        let media = { average: 0, total: 0, length: 0 };
        let min = null;
        let max = null;
        let last = null;
        visibleValues.forEach((event) => {
            const item = findMeasureRegister(event, meas.vc_fieldName);
            const val = numericValue(item?.nu_value);
            if (val !== null) {
                lastObj = { ...item, createdAt: event.createdAt }
                last = val
                data.push([moment(event.createdAt).format('DD-MM-YY HH:mm:ss'), val, event.createdAt])
                if (val >= max || max === null) max = val;
                if (val <= min || min === null) min = val;
                media = {
                    average: ((media.total + val) / (media.length + 1)).toFixed(2),
                    total: (media.total + val),
                    length: (media.length + 1),
                };
            } else {
                data.push([moment(event.createdAt).format('DD-MM-YY HH:mm:ss'), null, event.createdAt])
            }
        });
        series.push({
            name: meas?.vc_nombre,
            data: data,
            measure: meas,
            color: colorsArray[indexMeas],
            min: meas.nu_min || null,
            max: meas.nu_max || null,
            gauge: {
                color: last > media.average ? '#FB0000' : colorsArray[indexMeas],
                value: last,
                max,
                min,
                ...media
            }
        })
    })

    let min = [...series].map(e => e.min).sort(function (a, b) { return a - b })[0] || null;
    // console.log('min', min);
    if (min !== null) {
        gauge.min = {
            value: min,
            type: 'range'
        }
    } else {
        gauge.min = {
            value: ([...series].map(e => e.gauge?.min).sort(function (a, b) { return a - b })[0] || null)?.nu_min,
            type: 'measures'
        }
    }
    let max = [...series].map(e => e.max).sort(function (a, b) { return b - a })[0] || null;
    // console.log('max', max);
    if (max !== null) {
        gauge.max = {
            value: max,
            type: 'range'
        }
    } else {
        gauge.max = {
            value: [...series].map(e => e.gauge?.max).sort(function (a, b) { return a - b })[0] || null,
            type: 'measures'
        }
    }
    // console.log('series', series);
    return ({ valuesResponse: visibleValues, lastObj, gauge, bat, options: { ...customConfig.options, xaxis: { type: 'datetime', categories: categories } }, series })
};

const getPointKey = (point = []) => point[2] || point[0];

export const buildRegisterRows = (series = [], limit = 50) => {
    const rowsByDate = new Map();

    series.forEach((serie, serieIndex) => {
        (serie?.data || []).forEach((point) => {
            const key = getPointKey(point);
            if (!key) return;

            const current = rowsByDate.get(key) || {
                key,
                date: point[0],
                timestamp: point[2] || point[0],
                values: Array(series.length).fill(null),
            };
            current.values[serieIndex] = point;
            rowsByDate.set(key, current);
        });
    });

    return [...rowsByDate.values()]
        .filter((row) => row.values.some((point) => numericValue(point?.[1]) !== null))
        .sort((a, b) => moment(b.timestamp).valueOf() - moment(a.timestamp).valueOf())
        .slice(0, limit);
};
